import OSS from "ali-oss";

// const client = new OSS({
//   region: "oss-cn-shanghai",
//   accessKeyId: "LTAI5tDUTZGgxwVDjyKfnWVp",
//   accessKeySecret: "bSf0Z1CrvLBlwxcd2SIfV5boj7vNgQ",
//   // bucket: 'lation-ht-photos',
//   bucket: "lation-platform",
//   endpoint: "oss-cn-shanghai.aliyuncs.com"
// });

const ossConfig = {
  region: "oss-cn-shanghai",
  accessKeyId: 'LTAI5tNaHaTpwHZtUZWXLnPa',
  accessKeySecret: 'XfMORwXiVxRkEUXTNS0VTlfcpFbuG5',
  // bucket: 'lation-ht-photos',
  bucket: 'lation-platform',
  endpoint: 'oss-cn-shanghai.aliyuncs.com'
}
const client = new OSS(ossConfig)

// 测试 ali oss
window.ossTest = () => {
  let signUrl = aliOssTest("user/images/admin/admin_20210306175734323.jpg");

  let imgDom = document.createElement("img");
  imgDom.src = signUrl;
  document.getElementById("app").appendChild(imgDom);
};

// 依据oss图片地址返回图片防盗链地址
function aliOssTest(ossInImg) {
  // 图片名字，过期时间1分钟, 图片处理式样"style/jpg"
  let signUrl = client.signatureUrl(ossInImg, { expires: 6000 });
  signUrl = decodeURIComponent(signUrl);
  return signUrl;
}

/**
 * @function uploadToAlioss 上传文件至oss
 * @param file 文件数组 数组长度为 1
 * @param url 文件路径（带文件名）
 * @returns {Promise<*|null>}
 */
async function uploadToAlioss(file, url) {
  try {
    return await client.put(url, file[0]);
  } catch (error) {
    return null;
  }
}

/**
 * @function flieListAlioss 搜索文件夹目录内的文件list
 * @param prefix 目录路径或者搜索的文件名前缀 为null或者空时, 列出该目录下所有文件
 * @returns {Promise<void>} 默认最多返回1000个文件
 */
function flieListAlioss(prefix) {
  try {
    return client.list({
      prefix: prefix ? prefix : undefined,
    })
  } catch (e) {
    return null
  }
}

/**
 * @function getAliossAFile 搜索文件夹目录内的文件list
 * @param prefix 目录路径或者搜索的文件名前缀 为null或者空时, 列出该目录下所有文件
 * @returns {Promise<void>} 默认最多返回1000个文件
 */
function getAliossAFile(prefix){
  // try {
  //   return client.get({
  //     prefix: prefix ? prefix : undefined,
  //   })
  // } catch (e) {
  //   return null
  // }

  return client.get(prefix)
}

export const accessUrl =
  "https://yangzi-manage.oss-cn-shanghai.aliyuncs.com/mall/static/assets/";

export default {
  install: function(Vue) {
    Vue.prototype.$aliOssTest = ossInImg => aliOssTest(ossInImg);
    Vue.prototype.$uploadToAlioss = (file, url) => uploadToAlioss(file, url);
    Vue.prototype.$flieListAlioss = (prefix) => flieListAlioss(prefix);
    Vue.prototype.$getAliossAFile = (prefix) => getAliossAFile(prefix);
    Vue.prototype.$accessUrl = accessUrl;
  }
};



// WEBPACK FOOTER //
// ./src/util/aliOss.js